/**
 * Parse HTML comment markers embedded in agent text.
 *
 * Supported markers:
 *   <!--brainstorm:{"phase":"UNDERSTAND"}-->
 *   <!--chips:["Yes, build it","Change the plan"]-->
 *
 * Returns the cleaned text (markers stripped) plus any parsed metadata.
 */
export interface AgentMarkers {
  text: string;
  brainstormPhase: string | null;
  chips: string[];
}

const BRAINSTORM_RE = /<!--brainstorm:(\{[^>]*\})-->/g;
const CHIPS_RE = /<!--chips:(\[[^>]*\])-->/g;
const COMMENT_RE = /<!--[^>]*-->/g;

export function parseAgentMarkers(raw: string): AgentMarkers {
  let brainstormPhase: string | null = null;
  const chips: string[] = [];

  // Extract brainstorm marker
  for (const match of raw.matchAll(BRAINSTORM_RE)) {
    try {
      const parsed = JSON.parse(match[1]) as Record<string, unknown>;
      if (typeof parsed.phase === "string") {
        brainstormPhase = parsed.phase;
      }
    } catch {
      // ignore malformed marker
    }
  }

  // Extract chips marker
  for (const match of raw.matchAll(CHIPS_RE)) {
    try {
      const parsed = JSON.parse(match[1]);
      if (Array.isArray(parsed)) {
        for (const chip of parsed) {
          if (typeof chip === "string") chips.push(chip);
        }
      }
    } catch {
      // ignore malformed marker
    }
  }

  // Strip all HTML comment markers from the visible text
  const text = raw.replace(COMMENT_RE, "").trimEnd();

  return { text, brainstormPhase, chips };
}
